export default __webpack_public_path__ + "static/media/see-for-yourself.674e2e6a.svg";